import { bus_laixe } from '../../models/response/bus/bus_laixe';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_LAIXE_PATH = "bus/lai-xe";

class BusLaiXeApi extends BaseCRUDApi<bus_laixe> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busLaiXeApi = new BusLaiXeApi(API_BUS_LAIXE_PATH);
